/* OIDC default Redirect URIs constant*/
import {EMAIL, FIRST_NAME, LAST_NAME, USER_DISPLAY_NAME, USER_PRINCIPAL_NAME} from "./samlConstants";

export const DEFAULT_REDIRECT_URI_TYPE = 0;
export const DEFAULT_REDIRECT_URIS = [
  {
    "redirectUri": "",
    "redirectUriType": DEFAULT_REDIRECT_URI_TYPE
  }
]
/* default OIDC scope constant*/
export const DEFAULT_SCOPE = [
  {
    "scopeName": "profile",
    "isDefault": true,
    "oidcCustomClaims": [
      {
        "oidcCustomClaimName": "name",
        "idpUserAttributeEnum": USER_DISPLAY_NAME,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      },
      {
        "oidcCustomClaimName": "given_name",
        "idpUserAttributeEnum": FIRST_NAME,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      },
      {
        "oidcCustomClaimName": "family_name",
        "idpUserAttributeEnum": LAST_NAME,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      },
      {
        "oidcCustomClaimName": "upn",
        "idpUserAttributeEnum": USER_PRINCIPAL_NAME,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      }
    ]
  },
  {
    "scopeName": "email",
    "isDefault": true,
    "oidcCustomClaims": [
      {
        "oidcCustomClaimName": "email",
        "idpUserAttributeEnum": EMAIL,
        "oidcCustomClaimValue": "",
        "addClaimToIdToken": true,
        "addClaimToAccessToken": false
      }
    ]
  }
];

export const NEW_OIDC_CLAIM = {
  "oidcCustomClaimName": "",
  "idpUserAttributeEnum": USER_DISPLAY_NAME,
  "oidcCustomClaimValue": "",
  "addClaimToIdToken": true,
  "addClaimToAccessToken": false
}

export const NEW_OIDC_SCOPE = {
  "scopeName": "",
  "oidcCustomClaims": [
    {
      "oidcCustomClaimName": "",
      "idpUserAttributeEnum": USER_DISPLAY_NAME,
      "oidcCustomClaimValue": "",
      "addClaimToIdToken": true,
      "addClaimToAccessToken": false
    }
  ]
}

export const OIDC_WORKFLOW_NAME_WEBSSO = "WEBSSO";
export const OIDC_WORKFLOW_NAME_EPCS = "EPCS";

/* Default ACR Workflows */
export const DEFAULT_ACR_WORKFLOWS = [
  { acrValue: 'eidas2', workflowCode: OIDC_WORKFLOW_NAME_WEBSSO, isDefault: true }
];

export const DEFAULT_OIDC_ENTRA_ID_EAM_REDIRECT_URI = "https://login.microsoftonline.com/common/federation/externalauthprovider";

